<script setup>
import WelcomeItem from './WelcomeItem.vue'
import { SwapHorizontalOutline, HelpBuoyOutline } from '@vicons/ionicons5'

const welcomeItems = [
  {
    heading: 'Bio-inf data',
    text: 'Variants, Sequins, Groups, Blends.',
  },
  {
    heading: 'Production Data',
    text: 'Product parts, lots, locations, boxes, orders.',
  },
  {
    heading: 'Integration with CRM',
    text: 'Part reservations, counts, Azenta.',
    icon: SwapHorizontalOutline,
  },
  {
    heading: 'Support and Assistance',
    text: 'Need assistance? Reach out on the Teams Inventory channel or contact the Software team via teams or email.',
    icon: HelpBuoyOutline,
  },
]
</script>

<template>
  <WelcomeItem v-for="(item, index) in welcomeItems" :key="index">
    <template #icon v-if="item.icon">
      <component :is="item.icon" />
    </template>
    <template #heading>{{ item.heading }}</template>
    {{ item.text }}
  </WelcomeItem>
</template>
